export class UserDepositInfo {
  constructor(
    public lastDepositDate: string = '',
    public lastDepositAmount: number = 0,
    public totalDepositAmount: number = 0,
    public depositsCount: number = 0,
  ) {}
}
